// Shared visual constants for the Intelligence Graph UI.

export const CATEGORY_COLORS = {
  actor: "#dc2626",       // people / roles
  identifier: "#2563eb",  // phones / emails / images
  content: "#475569",     // advertisements
  asset: "#d97706",       // vehicles
  place: "#0d9488",       // hotels / locations / safe houses
  hub: "#7c3aed",         // transport hubs
  org: "#4f46e5",         // organisations / agencies
  case: "#db2777",        // police cases
  other: "#64748b",
};

export const CATEGORY_LABELS = {
  actor: "People & roles",
  identifier: "Identifiers",
  content: "Advertisements",
  asset: "Assets",
  place: "Places",
  hub: "Transport hubs",
  org: "Organisations",
  case: "Cases",
  other: "Other",
};

export function categoryColor(category) {
  return CATEGORY_COLORS[category] || CATEGORY_COLORS.other;
}

export function prettyType(t) {
  return (t || "").replace(/_/g, " ");
}

export const SCORE_TONE = {
  high: "bg-red-50 text-red-800 border-red-200",
  medium: "bg-amber-50 text-amber-800 border-amber-200",
  low: "bg-teal-50 text-teal-800 border-teal-200",
};
